module.exports = __webpack_public_path__ + "img/mobY.9d881962.svg";